




import { useUser } from '@checkout/composables';
import { computed, defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'UserInfo',
  setup() {
    const { userEmail } = useUser();

    const formattedEmail = computed(() => {
      // Replace @ with a zero-width space + @ to break the email detection
      return userEmail.value?.replace('@', '\u200B@') || '';
    });

    return {
      formattedEmail
    };
  }
});
